module.exports = __webpack_public_path__ + "static/media/0010_IMG_LE_SOL_MEGALITH_MEGABLACK.4dd6147f.png";